export type SnakStoreKey = 'success' | 'warn' | 'error';

export const SNACK_TYPE: { [K in SnakStoreKey]: SnakStoreKey } = {
  success: 'success',
  warn: 'warn',
  error: 'error',
};
